import { Image } from '../types/pages'

export const getImageSrc = (image: Image): string => {
  if (typeof image === 'string') {
    return image
  }

  if (image && image.childImageSharp) {
    return image.childImageSharp.fluid.src
  }

  return null
}

export const backgroundImageStyle = (image: Image) => {
  return {
    backgroundImage: `url(${getImageSrc(image)})`,
  }
}
